import { HelpCircle } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Button } from "@/components/ui/button";

interface HelpTooltipProps {
  content: string;
  learnMoreUrl?: string;
  onLearnMore?: () => void;
}

export function HelpTooltip({ content, learnMoreUrl, onLearnMore }: HelpTooltipProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button variant="ghost" size="icon" className="h-5 w-5 p-0" aria-label="More information">
            <HelpCircle className="h-4 w-4 text-muted-foreground" />
          </Button>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">
          <p className="text-sm">{content}</p>
          {(learnMoreUrl || onLearnMore) && (
            <button
              onClick={(e) => {
                e.preventDefault();
                if (onLearnMore) {
                  onLearnMore();
                } else if (learnMoreUrl) {
                  window.open(learnMoreUrl, '_blank');
                }
              }}
              className="text-xs text-primary hover:underline mt-1 block"
            >
              Learn More →
            </button>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
